var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import Logo from '@doordash/component-logo';
import * as queryString from 'query-string';
import { Inset, Text, Stack, Icon, StackChildren, } from '@doordash/design-language';
import Button from '@doordash/component-button';
import ProductOptionsStrings from './ProductOptionsStrings';
import ProductOptionTile from './ProductOptionTile';
import { dasspassForWorkTileContent, giftCardsTileContent, smallTeamTileContent, corporateOrderingTileContent, selfServeDPWTileContent, enterpriseDPWTileContent, PageSections, } from './ProductOptionsPageData';
import EmployeeMealOrderingTable from './EmployeeMealOrderingTable';
import { useMediaQuery } from '../../Common/MediaQueryProvider';
import TalkToSalesModal from './TalkToSalesModal';
import { selfServeRoutes } from '../../AppStructure/PublicRoutes';
import track from '../../../utils/track';
import LocationPathHelper from '../../../utils/location_path_helper';
import { IMAGE_BASE_URL, DDFW_GIFT_CARD_URL } from '../../../constants/values';
import ScrollIntoHorizontalView from '../../Common/ScrollIntoHorizontalView';
import { FullScreenContainer, CategoryImg, HeaderIconsContainer, PageTitleText, PageSubtitleText, PageHeader, SectionTitleText, SectionSubtitleText, SectionHeaderContainer, SubSectionTitleText, IconAndText, IconContainer, SubSectionHeaderContainer, CategoryIconContainer, GiftCardBenefitsContainer, GiftCardListContainer, GiftCardListItem, SectionDivider, } from './ProductOptionsStyles';
import { useCreateSelfServeLeadMutation } from './useCreateSelfServeLeadMutation';
import { COUNTRY_CODE } from './types/countryCode';
import { DYNAMIC_VALUES_NAME } from '../../DynamicValues';
import { useIsDynamicBooleanEnabled } from '../../DynamicValues/hook';
import { WorkBenefit } from '../../../types/GloblalTypes';
import { SelfServeProductOptionsEvents } from '../../../constants/events';
var EMPLOYEE_MEAL_STATIC_IMG_URL = IMAGE_BASE_URL + "/s/managed/consumer/teams/employee-meal-ordering-static-final.png";
var EMPLOYEE_MEAL_ACTIVE_IMG_URL = IMAGE_BASE_URL + "/s/managed/consumer/teams/employee-meal-ordering-active-final.png";
var EMPLOYEE_PERKS_STATIC_IMG_URL = IMAGE_BASE_URL + "/s/managed/consumer/teams/employee-perks-static-final.png";
var EMPLOYEE_PERKS_ACTIVE_IMG_URL = IMAGE_BASE_URL + "/s/managed/consumer/teams/employee-perks-active-final.png";
var CategoryIcon = function (_a) {
    var imgUrl = _a.imgUrl, description = _a.description, isMobile = _a.isMobile, onClickCategory = _a.onClickCategory;
    return (React.createElement(CategoryIconContainer, { onClick: onClickCategory },
        React.createElement(CategoryImg, { alt: description, src: imgUrl, isMobile: isMobile }),
        React.createElement(Text, { styles: Text.Styles.Body1, mobileStyles: Text.Styles.Caption2, textAlign: Text.TextAlignments.Center }, description)));
};
var SupportSection = function (_a) {
    var isMobile = _a.isMobile, callToAction = _a.callToAction;
    return (React.createElement(Stack, { size: Stack.Sizes.XxxLarge },
        React.createElement(SectionHeaderContainer, { isMobile: isMobile },
            React.createElement(SectionTitleText, null, ProductOptionsStrings.supportSectionTitle()),
            React.createElement(Inset, { size: Inset.Sizes.Large },
                React.createElement(Text, { styles: Text.Styles.Body1, textAlign: Text.TextAlignments.Center }, ProductOptionsStrings.supportSectionSubtitle())),
            React.createElement(Button, { size: Button.Sizes.Medium, type: Button.Types.Tertiary, isInline: isMobile ? false : true, onClick: callToAction }, ProductOptionsStrings.contactSalesButton()))));
};
var BenefitsSection = function (_a) {
    var isMobile = _a.isMobile, openDPWModal = _a.openDPWModal, openGiftCardPage = _a.openGiftCardPage;
    return (React.createElement("div", null,
        React.createElement(ProductOptionTile, { isMobile: isMobile, tileContent: dasspassForWorkTileContent, callToAction: openDPWModal }),
        React.createElement(ProductOptionTile, { isMobile: isMobile, tileContent: giftCardsTileContent, callToAction: openGiftCardPage })));
};
var BenefitsSectionWithSelfServeDashPass = function (_a) {
    var isMobile = _a.isMobile, openDPWModal = _a.openDPWModal, openGiftCardPage = _a.openGiftCardPage, navigateToSignUpTeamWithDashPass = _a.navigateToSignUpTeamWithDashPass;
    var giftCardBenefitStrings = [
        ProductOptionsStrings.giftCardsSection.item1(),
        ProductOptionsStrings.giftCardsSection.item2(),
    ];
    var dashPassDescriptionStrings = [
        ProductOptionsStrings.dashPassForWorkSection.description1(),
        ProductOptionsStrings.dashPassForWorkSection.description2(),
        ProductOptionsStrings.dashPassForWorkSection.description3(),
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(SubSectionHeaderContainer, { isMobile: isMobile },
            React.createElement(SubSectionTitleText, null,
                React.createElement(IconAndText, null,
                    React.createElement(IconContainer, null,
                        React.createElement(Icon, { type: Icon.Types.LogoDashpassNew, size: Icon.Sizes.Large, color: Icon.Colors.TextDashpass })),
                    React.createElement(Text, { styles: Text.Styles.Title1, mobileStyles: Text.Styles.Title2 }, ProductOptionsStrings.dashPassForWorkSection.title()))),
            React.createElement(Inset, { size: Inset.Sizes.Large },
                React.createElement(StackChildren, { size: Stack.Sizes.Small }, dashPassDescriptionStrings.map(function (descriptionString, index) { return (React.createElement(Text, { key: "dashpass-description-string-" + index, styles: Text.Styles.Body1, textAlign: Text.TextAlignments.Center }, descriptionString)); })))),
        React.createElement(Stack, { size: Stack.Sizes.Large },
            React.createElement(ProductOptionTile, { isMobile: isMobile, tileContent: selfServeDPWTileContent, callToAction: navigateToSignUpTeamWithDashPass }),
            React.createElement(ProductOptionTile, { isMobile: isMobile, tileContent: enterpriseDPWTileContent, callToAction: openDPWModal })),
        React.createElement(SubSectionHeaderContainer, { isMobile: isMobile },
            React.createElement(SubSectionTitleText, null,
                React.createElement(Text, { styles: Text.Styles.Title1, mobileStyles: Text.Styles.Title2, textAlign: Text.TextAlignments.Center }, ProductOptionsStrings.giftCardsSection.title())),
            React.createElement(Inset, { size: Inset.Sizes.Large },
                React.createElement(StackChildren, { size: Stack.Sizes.Small },
                    React.createElement(Text, { styles: Text.Styles.Body1, textAlign: Text.TextAlignments.Center }, ProductOptionsStrings.giftCardsSection.description())))),
        React.createElement(GiftCardBenefitsContainer, null,
            React.createElement(GiftCardListContainer, null, giftCardBenefitStrings.map(function (benefitString, index) { return (React.createElement(GiftCardListItem, { key: "gift-card-benefit-string-" + index },
                React.createElement(Text, { styles: Text.Styles.Body2Emphasis }, benefitString))); })),
            React.createElement(Button, { type: Button.Types.Primary, onClick: openGiftCardPage }, ProductOptionsStrings.giftCardsSection.cta())),
        React.createElement(SectionDivider, { isMobile: isMobile })));
};
export var ProductOptions = function () {
    var _a = __read(React.useState(false), 2), signUpTrackingEventFired = _a[0], setSignUpTrackingEventFired = _a[1];
    var fireSignupTrackingEvent = function (workBenefit) {
        if (signUpTrackingEventFired) {
            return;
        }
        setSignUpTrackingEventFired(true);
        if (workBenefit === WorkBenefit.WORK_BENEFIT_DASHPASS) {
            track(SelfServeProductOptionsEvents.DASHPASS_SIGN_UP);
        }
        else {
            track(SelfServeProductOptionsEvents.EXPENSED_MEALS_SIGN_UP);
        }
    };
    var isSelfServeDpEnabled = useIsDynamicBooleanEnabled(DYNAMIC_VALUES_NAME.ddfwSelfServeDP);
    var isMobile = useMediaQuery().isMobile;
    var history = useHistory();
    var _b = __read(React.useState(false), 2), isTalkToSalesModalVisible = _b[0], setIsTalkToSalesModalVisible = _b[1];
    var _c = __read(React.useState(null), 2), selectedPageSection = _c[0], setSelectedPageSection = _c[1];
    var _d = __read(React.useState(null), 2), leadId = _d[0], setLeadId = _d[1];
    var openTalkToSalesModal = function (ctaSource) {
        track(SelfServeProductOptionsEvents.VIEW_TALK_SALES_MODAL, {
            source: ctaSource,
        });
        setIsTalkToSalesModalVisible(true);
    };
    var closeTalkToSalesModal = function () { return setIsTalkToSalesModalVisible(false); };
    var openDPWModal = function () { return openTalkToSalesModal('Dashpass For Work'); };
    var openCorpOrderModal = function () { return openTalkToSalesModal('Corporate Ordering'); };
    var openSupportModal = function () { return openTalkToSalesModal('Support Section'); };
    var openGiftCardPage = function () {
        track(SelfServeProductOptionsEvents.VIEW_TALK_SALES_MODAL, {
            source: 'Gift Card',
        }, {}, function () {
            // redirect to the bulk gift card portal
            window.location.href = DDFW_GIFT_CARD_URL;
        });
    };
    var search = LocationPathHelper.getWindowLocationSearch() || '';
    var _e = queryString.parse(search), email = _e.email, phone = _e.phone, _f = _e.firstName, firstName = _f === void 0 ? '' : _f, lastName = _e.lastName, companyName = _e.companyName, _g = _e.totalCount, totalCount = _g === void 0 ? '' : _g;
    var createLead = useCreateSelfServeLeadMutation({
        email: email,
        phoneNumber: phone,
        firstName: firstName,
        lastName: lastName,
        countryCode: COUNTRY_CODE.US,
        companyName: companyName,
        companySize: totalCount,
    }).createLead;
    React.useEffect(function () {
        function getLeadId() {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var data, leadIdData;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, createLead()];
                        case 1:
                            data = _b.sent();
                            leadIdData = ((_a = data === null || data === void 0 ? void 0 : data.createSelfServeLead) === null || _a === void 0 ? void 0 : _a.leadId) || null;
                            setLeadId(leadIdData);
                            return [2 /*return*/];
                    }
                });
            });
        }
        getLeadId();
        // eslint-disable-next-line
    }, []);
    var navigateToSignUpTeamWithExpensedMeals = function () {
        navigateToSignUpTeam(WorkBenefit.WORK_BENEFIT_EXPENSED_MEALS);
    };
    var navigateToSignUpTeamWithDashPass = function () {
        navigateToSignUpTeam(WorkBenefit.WORK_BENEFIT_DASHPASS);
    };
    var navigateToSignUpTeam = function (workBenefit) {
        fireSignupTrackingEvent(workBenefit);
        var urlQueryString = search;
        if (!!leadId) {
            urlQueryString = urlQueryString + "&leadId=" + leadId;
        }
        urlQueryString = urlQueryString + "&workBenefit=" + workBenefit;
        history.push({
            pathname: selfServeRoutes.SIGN_UP_TEAM_ROUTE,
            search: urlQueryString,
        });
    };
    return (React.createElement(FullScreenContainer, null,
        React.createElement(PageHeader, { isMobile: isMobile },
            React.createElement(Logo, { type: Logo.Types.LogoMark, size: Logo.Sizes.Medium }),
            React.createElement(Inset, { size: isMobile ? Inset.Sizes.Medium : Inset.Sizes.Large },
                React.createElement(PageTitleText, null, ProductOptionsStrings.pageTitle()),
                React.createElement(PageSubtitleText, null, ProductOptionsStrings.pageSubtitle())),
            React.createElement(HeaderIconsContainer, { isMobile: isMobile },
                React.createElement(CategoryIcon, { isMobile: isMobile, imgUrl: selectedPageSection === PageSections.EmployeeMeals
                        ? EMPLOYEE_MEAL_ACTIVE_IMG_URL
                        : EMPLOYEE_MEAL_STATIC_IMG_URL, description: ProductOptionsStrings.categoryEmployeeMeals(), onClickCategory: function () {
                        return setSelectedPageSection(PageSections.EmployeeMeals);
                    } }),
                React.createElement(CategoryIcon, { isMobile: isMobile, imgUrl: selectedPageSection === PageSections.EmployeePerks
                        ? EMPLOYEE_PERKS_ACTIVE_IMG_URL
                        : EMPLOYEE_PERKS_STATIC_IMG_URL, description: ProductOptionsStrings.categoryEmployeePerks(), onClickCategory: function () {
                        return setSelectedPageSection(PageSections.EmployeePerks);
                    } }))),
        React.createElement(SectionHeaderContainer, { isMobile: isMobile },
            React.createElement(ScrollIntoHorizontalView, { behavior: 'smooth', isSelected: selectedPageSection === PageSections.EmployeeMeals },
                React.createElement(SectionTitleText, null, ProductOptionsStrings.employeeMealSectionTitle())),
            React.createElement(SectionSubtitleText, null, ProductOptionsStrings.employeeMealSectionSubtitle())),
        isMobile ? (React.createElement(React.Fragment, null,
            React.createElement(ProductOptionTile, { isMobile: isMobile, hasListCell: true, tileContent: smallTeamTileContent, callToAction: navigateToSignUpTeamWithExpensedMeals }),
            React.createElement(ProductOptionTile, { isMobile: isMobile, hasListCell: true, tileContent: corporateOrderingTileContent, callToAction: openCorpOrderModal }))) : (React.createElement(EmployeeMealOrderingTable, { onClickSignupNow: navigateToSignUpTeamWithExpensedMeals, onClickContactUs: openCorpOrderModal })),
        React.createElement(SectionHeaderContainer, { isMobile: isMobile },
            React.createElement(ScrollIntoHorizontalView, { behavior: 'smooth', isSelected: selectedPageSection === PageSections.EmployeePerks },
                React.createElement(SectionTitleText, null, ProductOptionsStrings.employeePerksSectionTitle())),
            React.createElement(SectionSubtitleText, null, ProductOptionsStrings.employeePerksSectionSubtitle())),
        !isSelfServeDpEnabled && (React.createElement(BenefitsSection, { isMobile: isMobile, openDPWModal: openDPWModal, openGiftCardPage: openGiftCardPage })),
        isSelfServeDpEnabled && (React.createElement(BenefitsSectionWithSelfServeDashPass, { isMobile: isMobile, openDPWModal: openDPWModal, openGiftCardPage: openGiftCardPage, navigateToSignUpTeamWithDashPass: navigateToSignUpTeamWithDashPass })),
        React.createElement(SupportSection, { isMobile: isMobile, callToAction: openSupportModal }),
        isTalkToSalesModalVisible && (React.createElement(TalkToSalesModal, { onClose: closeTalkToSalesModal }))));
};
export default ProductOptions;
